import { useState } from "react";
import { toast } from 'react-toastify';
import Axios from "../utils/axiosInstance";

const useDiscount = () => {
  const [discountedPrice, setDiscountedPrice] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const applyDiscount = async (discountCode, price) => {
    setLoading(true);
    setError(null);
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}shipment/calculate-discount/`,
        {
          discount_code: discountCode,
          price: price,
        }
      );
      toast.success("Discount Added!");
      setDiscountedPrice(response.data.data);
    } catch (err) {
      setDiscountedPrice(null)
      setError(err.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return { discountedPrice, applyDiscount, error, loading };
};

export default useDiscount;
